"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M22.5 7.62a1.44 1.44 0 00-.847-1.315A3359.985 3359.985 0 0112.5 2.108a1.225 1.225 0 00-1.028 0c-1.634.754-7.009 3.265-9.115 4.247a1.485 1.485 0 00-.855 1.35v10.802c0 .486.283.93.723 1.136l9.093 4.227a1.399 1.399 0 001.172.002l9.167-4.197a1.453 1.453 0 00.848-1.325V7.62H22.5zM11.917 3.822l7.576 3.45-7.58 3.446-7.441-3.45 7.445-3.446zm.88 17.978l.003-9.552 7.937-3.613-.004 9.552-7.936 3.613z" }), "Offer");
//# sourceMappingURL=Offer.js.map